export const buildMeetingTasks = (
  meeting: Record<string, any>,
  meetingId: string | number,
) =>
  String(meeting.next_steps ?? "")
    .split(/\r?\n/)
    .map((line) => line.replace(/^[-*]\s*/, "").trim())
    .filter(Boolean)
    .map((text) => ({
      meeting_id: meetingId,
      company_id: meeting.company_id ?? null,
      deal_id: meeting.deal_id ?? null,
      sales_id: meeting.sales_id,
      type: "follow-up",
      text,
      due_date: new Date(Date.now() + 24 * 60 * 60 * 1000).toISOString(),
      priority: "medium",
      status: "pending",
    }));
